import { apiBaseURL } from '../ProjectConstants';

/*
 =-=-=-=-=- data structure -=-=-=-=-=
 	id: int,
	vendors: [{
		name:str
        trackingNumber: str
		items: [{
			billingCode: str,
			deliveryLocationId: int,
			isOutOfStock: bool,
			itemName: str,
			itemNumber: str,
			notes: str,
			pricePerItem: int,
			quantity: int,
			url: str,
		}],
		}],
	urgency: int,
*/


async function handlePutOrders(data, statusId, fetch) {
    console.log(data)
    const vendors = data.vendors;
    vendors.forEach(x => delete x.id);
    const body = {
        id: data.id,
        requestorContactNumber: data.requestorContactNumber,
        vendors: vendors,
        urgency: data.urgency,
        urgencyJustification: (data.reasoning ?? "").trim(),
        status: statusId || data.statusId,
    };
 
    //const response = false;
    const response = await fetch.put(`${apiBaseURL}/api/Orders`, body);
    const isDataGood = response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model'

    console.log('handlePutOrders body', body);
    console.log('handlePutOrders response', response);

    return {
        response,
        isDataGood
    };
}
export default handlePutOrders;